import { gql } from "@apollo/client";

export const operatorFragment = gql`
  fragment OperatorFragment on Operator {
    code
    operatorValueType
  }
`;
